import { FC, memo, useMemo } from "react";
import {
    CompetitionGridItemNotAuto,
    CompetitionGridItemWrapper,
    CompetitionTags,
    InfoBlock,
    NameWrapper,
    StyledImgNotAuto
} from "./styled";
import { CompetitionCardProps } from "./types";
import { CompetitionLink, CompetitionView } from "./CompetitionView";
import { STATUSES } from "_competition/const";
import { Endpoints } from "@brg/api";
import { CompetitionTagLine } from "../../components/CompetitionTagLine";

export const CompetitionCard: FC<CompetitionCardProps> = memo((props) => {
  const { competitionProps, isModalCard, isSelected, isAlready, currentTagId, selectRingPosition, onSelect, isProfile, isMainPage } = props;
  const urlBase = Endpoints.files
  const url = competitionProps?.titleImages?.length ? `${urlBase}/${competitionProps?.titleImages[0]?.url}` : '';

  const competitionPath = useMemo(
    () => (competitionProps?.status === STATUSES.Completed
      ? `/competition/${competitionProps?.competitionId}?tab=shortlist`
      : `/competition/${competitionProps?.competitionId}`), [competitionProps])

  const link = competitionProps?.link;

  const onClick = (e: any) => {
    if (link?.length) {
      e.preventDefault();
      e.stopPropagation();
      window.open(link, '_blank');
    }
  }

  if (props.isNewType) {
    const hasTags = competitionProps?.requredTags?.length > 0 || competitionProps?.regularTags?.length > 0;
    const isCompletedOnMainPage = isMainPage && competitionProps?.status === STATUSES.Completed;
    
    return (
      <CompetitionGridItemWrapper className="CompetitionGridItemWrapper" isModal={isModalCard}>
        <CompetitionView 
          competition={competitionProps} 
          needLink={true} 
          isMainPage 
          isSelected={isSelected && isModalCard}
          isAlready={isAlready && isModalCard} 
          isModalCard={isModalCard}
          selectRingPosition={selectRingPosition}
          onSelect={onSelect}
          isProfile={isProfile} 
          />
        <CompetitionTags>
          {competitionProps && !isModalCard && (hasTags || isCompletedOnMainPage) &&
              <CompetitionTagLine competitionProps={competitionProps} currentTagId={currentTagId} />}
        </CompetitionTags>
      </CompetitionGridItemWrapper>
    );
  }

  return (
    <CompetitionGridItemNotAuto className="CompetitionGridItemNotAuto" isActual={competitionProps?.status === STATUSES.Open} >
      <CompetitionLink to={competitionPath} onClick={onClick}>
        <StyledImgNotAuto
        alt=""
        src={url}
        width="100%"
      />

      <InfoBlock>
        <NameWrapper>
          <div dangerouslySetInnerHTML={{__html: competitionProps?.name}}/>
        </NameWrapper>
      </InfoBlock>
      </CompetitionLink>
    </CompetitionGridItemNotAuto>
  );
});import { FC, memo, useMemo } from "react";
import {
    CompetitionGridItemNotAuto,
    CompetitionGridItemWrapper,
    CompetitionTags,
    InfoBlock,
    NameWrapper,
    StyledImgNotAuto
} from "./styled";
import { CompetitionCardProps } from "./types";
import { CompetitionLink, CompetitionView } from "./CompetitionView";
import { STATUSES } from "_competition/const";
import { Endpoints } from "@brg/api";
import { CompetitionTagLine } from "../../components/CompetitionTagLine";

export const CompetitionCard: FC<CompetitionCardProps> = memo((props) => {
  const { competitionProps, isModalCard, isSelected, isAlready, currentTagId, selectRingPosition, onSelect, isProfile, isMainPage } = props;
  const urlBase = Endpoints.files
  const url = competitionProps?.titleImages?.length ? `${urlBase}/${competitionProps?.titleImages[0]?.url}` : '';

  const competitionPath = useMemo(
    () => (competitionProps?.status === STATUSES.Completed
      ? `/competition/${competitionProps?.competitionId}?tab=shortlist`
      : `/competition/${competitionProps?.competitionId}`), [competitionProps])

  const link = competitionProps?.link;

  const onClick = (e: any) => {
    if (link?.length) {
      e.preventDefault();
      e.stopPropagation();
      window.open(link, '_blank');
    }
  }

  if (props.isNewType) {
    const hasTags = competitionProps?.requredTags?.length > 0 || competitionProps?.regularTags?.length > 0;
    const isCompletedOnMainPage = isMainPage && competitionProps?.status === STATUSES.Completed;
    
    return (
      <CompetitionGridItemWrapper className="CompetitionGridItemWrapper" isModal={isModalCard}>
        <CompetitionView 
          competition={competitionProps} 
          needLink={true} 
          isMainPage 
          isSelected={isSelected && isModalCard}
          isAlready={isAlready && isModalCard} 
          isModalCard={isModalCard}
          selectRingPosition={selectRingPosition}
          onSelect={onSelect}
          isProfile={isProfile} 
          />
        <CompetitionTags>
          {competitionProps && !isModalCard && (hasTags || isCompletedOnMainPage) &&
              <CompetitionTagLine competitionProps={competitionProps} currentTagId={currentTagId} />}
        </CompetitionTags>
      </CompetitionGridItemWrapper>
    );
  }

  return (
    <CompetitionGridItemNotAuto className="CompetitionGridItemNotAuto" isActual={competitionProps?.status === STATUSES.Open} >
      <CompetitionLink to={competitionPath} onClick={onClick}>
        <StyledImgNotAuto
        alt=""
        src={url}
        width="100%"
      />

      <InfoBlock>
        <NameWrapper>
          <div dangerouslySetInnerHTML={{__html: competitionProps?.name}}/>
        </NameWrapper>
      </InfoBlock>
      </CompetitionLink>
    </CompetitionGridItemNotAuto>
  );
});